import React, {FC} from "react"

import FormattedMessage, {InjectIntl, injectIntl} from "@irati/utils/lang"
import {H3, Body} from "@irati/ui/src/Typography"
import GenericModal from "@irati/ui/src/GenericModal"
import Flex from "@irati/ui/src/Flex"
import {RouterLink} from "@irati/ui/src/Link"

import {VIEW_PEOPLE} from "../../../routes/routeConfig"

interface Props extends InjectIntl {
  show: boolean
  users: number
  onClose: () => void
}

const SuccessModal: FC<Props> = ({show, users, onClose, formatMessage}) => {
  return (
    <GenericModal hideActions show={show} onHide={onClose}>
      <Flex justifyContent="center" alignItems="center" direction="column">
        <H3 marginBottom={4}>
          <FormattedMessage id="admin.components.updatePeopleCSV.successModal.title" />
        </H3>
        <img height="150px" src={formatMessage({id: "admin.components.updatePeopleCSV.successModal.img"})} />
        <Body marginTop={4} maxWidth="100%" weight="semibold">
          <FormattedMessage id="admin.components.updatePeopleCSV.successModal.subTitle" values={{count: users}} />
        </Body>
        <Body marginBottom={2} maxWidth="100%" weight="semibold">
          <FormattedMessage
            id="admin.components.updatePeopleCSV.successModal.subTitle2"
            values={{
              page: (
                <RouterLink to={VIEW_PEOPLE} onClick={onClose}>
                  <FormattedMessage id="admin.components.updatePeopleCSV.successModal.link" />
                </RouterLink>
              )
            }}
          />
        </Body>
      </Flex>
    </GenericModal>
  )
}

export default injectIntl(SuccessModal)
